import React from 'react';
import RatesSearchForm from '../Containers/RatesSearchForm/RatesSearchForm';
import SvgIcon from '../Components/Icons/SvgIcon';
import { Banner1, Banner2, Banner3 } from '../Components/Icons/HomeBanners';

const HomeRoute: React.FC = () => (
    <div>
        <div className="bg-gray-100 py-12">
            <div className="container max-w-6xl mx-auto bg-blue-600 rounded-lg pt-14 px-10 pt-20 pb-5">
                <div className="text-white text-center mx-auto max-w-lg">
                    <h1 className="font-bold text-2xl mb-3">Search historical car hire rates</h1>
                    <p>
                        Access our database of rates and availability obtained from the back end systems of car rental companies by VroomVroomVroom.
                    </p>
                </div>
                <div className="mx-auto px-5 mt-10">
                    <RatesSearchForm />
                </div>
            </div>
        </div>
        <div className="bg-white">
            <div className="container max-w-6xl mx-auto flex pt-5 pb-20">
                <div className="w-3/12">
                    <h1 className="text-2xl py-5 font-bold text-black-400">How it works:</h1>
                </div>
                <div className="w-9/12 flex">
                    <div className="w-4/12 p-3 flex flex-col">
                        <div className="rounded">
                            <SvgIcon className="w-full" viewBox="0 0 265 131" height="131">
                                <Banner1 />
                            </SvgIcon>
                        </div>
                        <div className="relative z-10 bg-gradient-to-b from-blue-200 to-blue-100 p-3 rounded-b-xl h-full">
                            <span className="flex items-center h-4 bg-white shadow shadow-lg rounded w-4 justify-center font-bold p-4 -mt-8">1</span>
                            <h3 className="font-bold text-base text-blue-900 mt-4 mb-2">Search a location</h3>
                            <p className="text-sm text-gray-700">
                                View rates for vehicles available for pick up from depots within a 5km radius of the specified location.
                            </p>
                        </div>
                    </div>
                    <div className="w-4/12 p-3 flex flex-col">
                        <div className="rounded">
                            <SvgIcon className="w-full" viewBox="0 0 265 131" height="131">
                                <Banner2 />
                            </SvgIcon>
                        </div>
                        <div className="relative z-10 bg-gradient-to-b from-blue-200 to-blue-100 p-3 rounded-b-xl h-full">
                            <span className="flex items-center h-4 bg-white shadow shadow-lg rounded w-4 justify-center font-bold p-4 -mt-8">2</span>
                            <h3 className="font-bold text-base text-blue-900 mt-4 mb-2">Set parameters</h3>
                            <p className="text-sm text-gray-700">
                                Specify your search parameters and run a search.
                            </p>
                        </div>
                    </div>
                    <div className="w-4/12 p-3 flex flex-col">
                        <div className="rounded">
                            <SvgIcon className="w-full" viewBox="0 0 265 131" height="131">
                                <Banner3 />
                            </SvgIcon>
                        </div>
                        <div className="relative z-10 bg-gradient-to-b from-blue-200 to-blue-100 p-3 rounded-b-xl h-full">
                            <span className="flex items-center h-4 bg-white shadow shadow-lg rounded w-4 justify-center font-bold p-4 -mt-8">3</span>
                            <h3 className="font-bold text-base text-blue-900 mt-4 mb-2">Export report</h3>
                            <p className="text-sm text-gray-700">
                                Filter and export your results to PDF.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
)

export default HomeRoute;
